import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps, EarningsByStaff } from "@customTypes/dashboard";
import { Pagination } from "@customTypes/index";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  const newData = [] as EarningsByStaff[];

  if (res.data.staff_earnings.length) {
    for (const i in res.data.staff_earnings) {
      const {
        threshold_for_next_commission,
        next_commission_percentage,
        current_commission_percentage,
        total_earnings,
        staff_role,
        staff_name,
        staff_id,
      } = res.data.staff_earnings[i];
      newData.push({
        id: staff_id,
        name: staff_name,
        role: staff_role,
        totalEarnings: total_earnings,
        currentCommissionPercentage: current_commission_percentage,
        nextCommissionPercentage: next_commission_percentage,
        thresholdForNextCommission: threshold_for_next_commission,
      });
    }
    // console.log(newData);
    return { newData, pagination };
  }

  return null;
};

export const useGetEarningsByStaff = ({
  dateRange,
  startDate,
  endDate,
  pagination,
  search,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.earningsByStaffWithFilters({
      dateRange,
      startDate,
      endDate,
      pagination,
      search,
    }),
    queryFn: () => {
      return api.get("analytics/earnings/staff", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          page: pagination?.page,
          page_size: pagination?.pageSize,
          ...(search && { search }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Earnings By Staff]", res);
      handleErrors(res, "query");
    },
  });
};
